import FileSaver from 'file-saver'

import { appConfig } from '@/config/appConfig'

const parseContentDispositionFileName = (
	header: string | null,
): string | undefined => {
	if (!header) return undefined

	const match = header.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/i)
	return match?.[1]?.trim()
}

export const downloadTaskResultFile = async (
	taskId: number,
	authToken: string,
	fallbackFileName: string,
): Promise<void> => {
	const response = await fetch(`${appConfig.apiUrl}/task/${taskId}/bin`, {
		headers: {
			Authorization: `Bearer ${authToken}`,
			'X-TenantId': appConfig.realm,
		},
	})

	if (!response.ok) {
		throw new Error(`Download failed (${response.status})`)
	}

	const arrayBuffer = await response.arrayBuffer()

	if (!arrayBuffer.byteLength) {
		throw new Error('Downloaded file is empty')
	}

	const fileName =
		parseContentDispositionFileName(
			response.headers.get('Content-Disposition'),
		) ?? fallbackFileName

	const blob = new Blob([new Uint8Array(arrayBuffer)], {
		type: response.headers.get('Content-Type') ?? 'application/octet-stream',
	})

	FileSaver.saveAs(blob, fileName)
}
